<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import DispatchSpeedSelector from './DispatchSpeedSelector.vue';
import DispatchTimeEstimate from './DispatchTimeEstimate.vue';

const props = defineProps({
  wizardData: { type: Object, required: true },
});

const emit = defineEmits(['update']);

const PROFILES = {
  conservative: {
    burst_size: 12,
    burst_delay_min_ms: 15000,
    burst_delay_max_ms: 30000,
    cooldown_min_seconds: 300,
    cooldown_max_seconds: 600,
  },
  moderate: {
    burst_size: 30,
    burst_delay_min_ms: 8000,
    burst_delay_max_ms: 15000,
    cooldown_min_seconds: 180,
    cooldown_max_seconds: 300,
  },
  aggressive: {
    burst_size: 45,
    burst_delay_min_ms: 4000,
    burst_delay_max_ms: 8000,
    cooldown_min_seconds: 60,
    cooldown_max_seconds: 120,
  },
};

const { t } = useI18n();

const throttleConfig = computed(
  () => props.wizardData.throttleConfig || { profile: 'moderate' }
);
const isLabel = computed(() => props.wizardData.audienceType === 'label');

const contactCount = computed(() => {
  if (isLabel.value) return props.wizardData.selectedAudience?.length || 0;
  return props.wizardData.csvTotalRows || 0;
});

const effectiveConfig = computed(() => {
  const profile = throttleConfig.value.profile || 'moderate';
  if (profile === 'custom') return throttleConfig.value;
  return PROFILES[profile] || PROFILES.moderate;
});

const handleSpeedUpdate = config => {
  emit('update', { throttleConfig: config });
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <h3 class="text-base font-medium text-n-slate-12">
      {{ t('CAMPAIGN.WHATSAPP.WIZARD.DISPATCH_SPEED.TITLE') }}
    </h3>
    <p class="text-sm text-n-slate-11">
      {{ t('CAMPAIGN.WHATSAPP.WIZARD.DISPATCH_SPEED.DESCRIPTION') }}
    </p>

    <DispatchSpeedSelector
      :throttle-config="throttleConfig"
      @update="handleSpeedUpdate"
    />

    <DispatchTimeEstimate
      :config="effectiveConfig"
      :contact-count="contactCount"
    />
  </div>
</template>
